/**
 * Route for `budget-pacing-alerts`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BudgetPacingAlertsPage } from "../features/budget-pacing-alerts/BudgetPacingAlertsPage";

export const budgetPacingAlertsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/budget-pacing-alerts",
	component: BudgetPacingAlertsPage,
});

export default budgetPacingAlertsRoute;
